import { Company } from "../generated/company-model";
import { Experience } from "../generated/experience-model";
import { File } from "../generated/file-model";
import { Investment } from "../generated/investment-model";
import { InvestmentStatusChangeLogEntry } from "../generated/investment-status-change-log-entry-model";
import { Payment } from "../generated/payment-model";
import { Sale } from "../generated/sale-model";
import { SignedUrl } from "../generated/signed-url-model";
import { User } from "../generated/user-model";
import { Wallet } from "../generated/wallet-model";

export type Upload = File

interface Props {
  type: string;
  name: string;
  inputType?: string;
  result?: any;
  excludeResult?: Array<string>;
  fragment?: string;
}

const InvestmentResult = Object.assign(
  new Investment(),
  { statusChangeLog: new InvestmentStatusChangeLogEntry() }
);

const SaleResult = Object.assign(
  new Sale(),
  { images: new File() }
);

const UserResult = Object.assign(
  new User(),
  {
    company: new Company(),
    experience: new Experience(),
    payments: new Payment(),
    wallet: new Wallet(),
  }
);

export function REQUEST ({
  type,
  name,
  inputType,
  result,
  excludeResult,
  fragment,
}: Props) {
  const unwrap = (obj: any): string => {
    return Object.keys(obj).reduce(
      (
        reduceResult, value
      ) => {
        return reduceResult + (!excludeResult || !excludeResult.includes(value) ? value + (typeof obj[value] === 'object' && !(obj[value] instanceof Date) ? ' {' + unwrap(obj[value]) + '}' : '') + "\n" : '');
      },
      "\n"
    );
  }

  return (
    `# Name: ${name} \n` +
    `${type} ${inputType ? `${name}(\n$input: ${inputType}!\n) ` : ''}{\n` +
    `${name}` +
    `${inputType ? `(\ninput: $input\n)` : ''}` +
    `${result && Object.keys(result).length > 0 ? ` {${unwrap(result)}}` : ''}` +
    `}` +
    `${fragment ? fragment : ''}`
  );
}

export const APPROVE_USER = REQUEST({
  type: 'mutation',
  name: "approveUser",
  inputType: "ApproveUserInput",
  result: UserResult,
});

export const CREATE_INVESTMENT = REQUEST({
  type: 'mutation',
  name: "createInvestment",
  inputType: "CreateInvestmentInput",
  result: InvestmentResult,
});

export const CREATE_PAYMENT = REQUEST({
  type: 'mutation',
  name: "createPayment",
  inputType: "CreatePaymentInput",
  result: new Payment(),
});

export const CREATE_SALE = REQUEST({
  type: 'mutation',
  name: "createSale",
  inputType: "CreateSaleInput",
  result: SaleResult,
});

export const CREATE_USER = REQUEST({
  type: 'mutation',
  name: "createUser",
  inputType: "CreateUserInput",
  result: UserResult,
});

export const DELETE_PAYMENT = REQUEST({
  type: 'mutation',
  name: "deletePayment",
  inputType: "DeletePaymentInput",
  result: new Payment(),
});

export const DELETE_SALE = REQUEST({
  type: 'mutation',
  name: "deleteSale",
  inputType: "DeleteSaleInput",
  result: SaleResult,
});

export const GET_CURRENT_USER = REQUEST({
  type: 'query',
  name: "getCurrentUser",
  result: UserResult,
});

export const GET_CURRENT_USER_INVESTMENTS = REQUEST({
  type: 'query',
  name: "getCurrentUserInvestments",
  result: InvestmentResult,
});

export const GET_IDNOW_USER = REQUEST({
  type: 'query',
  name: "getIdNowUser",
  inputType: "GetIdNowUserInput",
  result: UserResult,
});

export const GET_INVESTMENTS = REQUEST({
  type: 'query',
  name: "getInvestments",
  inputType: "GetInvestmentInput",
  result: InvestmentResult,
});

export const GET_SALES = REQUEST({
  type: 'query',
  name: "getSales",
  inputType: "GetSaleInput",
  result: SaleResult,
});

export const GET_USERS = REQUEST({
  type: 'query',
  name: "getUsers",
  result: UserResult,
});

export const GENERATE_UPLOAD_SIGNED_URL = REQUEST({
  type: 'mutation',
  name: "generateUploadSignedUrl",
  inputType: "GenerateUploadSignedUrlInput",
  result: new SignedUrl(),
})

export const LOGIN_USER = REQUEST({
  type: 'mutation',
  name: "loginUser",
  inputType: "LoginUserInput",
});

export const REGISTER_ADMIN_USER = REQUEST({
  type: 'mutation',
  name: "registerAdmin",
  inputType: "RegisterAdminUserInput",
});

export const REGISTER_USER = REQUEST({
  type: 'mutation',
  name: "registerUser",
  inputType: "RegisterUserInput",
});

export const UPDATE_INVESTMENT = REQUEST({
  type: 'mutation',
  name: "updateInvestment",
  inputType: "UpdateInvestmentInput",
  result: InvestmentResult,
});

export const UPDATE_USER = REQUEST({
  type: 'mutation',
  name: "updateUser",
  inputType: "UpdateUserInput",
  result: UserResult,
});